import TierLabel from './component.jsx'

export default TierLabel
